<nz-filter-trigger
  (nzVisibleChange)="onVisibilityChange($event)"
  [(nzVisible)]="visible"
  [nzDropdownMenu]="filterSearchMenu"
>
  <i nz-icon nzType="search" nzTheme="outline"></i>
</nz-filter-trigger>
<nz-dropdown-menu #filterSearchMenu="nzDropdownMenu">
  <ul nz-menu>
    <div class="table-filter-search-box">
      <input nz-input #inpSearch [placeholder]="placeholder" />
      <button
        nz-button
        nzSize="small"
        nzType="primary"
        class="search-button"
        (click)="filterChange(inpSearch.value)"
      >
        {{
          "GENERAL.GENERIC_TABLE.COLUMNS.CUSTOM_FILTER_SEARCHBUTTON" | translate
        }}
      </button>
      <button nz-button nzSize="small" (click)="resetFilter(inpSearch)">
        {{
          "GENERAL.GENERIC_TABLE.COLUMNS.CUSTOM_FILTER_RESETBUTTON" | translate
        }}
      </button>
    </div>
  </ul>
</nz-dropdown-menu>
